export default 'tkr.appconfig';
